// extracted by mini-css-extract-plugin
export var innerPageHeader = "inner-page-header-module--innerPageHeader--7wHXb";
export var heroPattern = "inner-page-header-module--heroPattern--1mmG4";